import { SubscriptionPlanDraft } from 'src/lib/types/subscriptions'

/** Stand-in copy and plans for the Subscribe preview, shown before any real plan exists. */
export const PRICE_PLACEHOLDER = '₹xxx'
export const SAVINGS_PLACEHOLDER = 'Save ₹200'

const OTHER_PLANS = [
  { intervalCount: 1, durationCount: 12 },
  { intervalCount: 3, durationCount: 6 }
]

export const MORE_PLANS_COUNT = OTHER_PLANS.length

export const SHEET_PLANS: SubscriptionPlanDraft[] = [
  { intervalCount: 2, durationValue: 6 },
  ...OTHER_PLANS.map(plan => ({ intervalCount: plan.intervalCount, durationValue: plan.durationCount }))
].map((plan, index) => ({
  localId: `preview-${index}`,
  intervalCount: plan.intervalCount,
  intervalUnit: 'MONTH',
  durationValue: plan.durationValue,
  discountType: 'PERCENTAGE',
  discountValue: 5,
  isRecommended: index === 0,
  status: 'ENABLED',
  rank: index,
  isCommitted: true
}))
